<template>
	<nav aria-label="Page navigation example" class="noprint">
	  <ul class="pagination">
	    <li class="page-item info" :class="{ disabled: source.current_page === 1}">
	      	<button class="page-link"  @click="first">
	      	  <i class="fa fa-angle-double-left"></i> 
	      	</button>
	    </li>
	    <li class="page-item info" :class="{ disabled: source.current_page === 1}">
	    	<button class="page-link" aria-label="Previous" @click="previous">
	      	  <i class="fas fa-angle-left"></i>
	      	</button>
	    </li>
	    <!--
	    <li class="page-item info" v-if="source.current_page > 3 && source.last_page > 5">
	    	<button class="page-link" @click="navigate(1)">
	    		1
	    	</button>
	    </li>
		-->
	    <li class="page-item info disabled" v-if="source.current_page > 3 && source.last_page > 5">
	    	<button class="page-link">
	    		...
	    	</button>
	    </li>
	    <li class="page-item info" v-for="page in pages" :class="{ active: source.current_page == page}">
	    	<button class="page-link" @click="navigate(page)">
	    		{{ page }}
	    	</button>
	    </li>
	    <li class="page-item info disabled" v-if="source.current_page < (source.last_page - 2) && source.last_page > 5">
	    	<button class="page-link">
	    		...
	    	</button>
	    </li>
	    <!--
	    <li class="page-item info" v-if="source.current_page < (source.last_page - 2)">
	    	<button class="page-link" @click="navigate(source.last_page)">
	    		{{ source.last_page }}
	    	</button>
	    </li>
		-->
	    <li class="page-item info" :class="{ disabled: source.current_page == source.last_page}">
	    	<button class="page-link" aria-label="next" @click="next">
	        	<i class="fas fa-angle-right"></i>
	      	</button>
	    </li> 
	    <li class="page-item info" :class="{ disabled: source.current_page == source.last_page}">
	      	<button class="page-link"  @click="last">
	        	<i class="fa fa-angle-double-right"></i> 
	      	</button>
	    </li> 
	  </ul>
	</nav> 
</template>

<script>

	import { range } from 'lodash'

	export default {
		props: ['source'],

		data() {
			return {
				pages: [],
			}
		},

		created() {
			this.setPages();
		},

		methods: {

			navigate(page) {
	            this.$emit('clickNav', page); 
	       	},

	       	first(){
	       		let page = 1;
	       		this.$emit('clickNav', 1);
	       	},

	       	last(){
	       		let page = this.source.last_page;
	       		this.$emit('clickNav', page);
	       	},

	       	previous(){
	       		let page = this.source.current_page - 1;
	       		this.$emit('clickNav', page);
	       	},

	       	next(){
	       		let page = this.source.current_page + 1;
	       		this.$emit('clickNav', page);
	       	},

	       	setPages(){
	       		let last_page = this.source.last_page;
	       		let current_page = this.source.current_page;

	       		if(last_page > 5){
		       		if(current_page <= 3){
		       			this.pages = range(1, 6);
		       		} else if(current_page >= (last_page-2)){
		       			this.pages = range(last_page-4, last_page+1);
		       		} else {
		       			this.pages = range(current_page-2, current_page+3);
		       		}
	       		} else {
	       			this.pages = range(1, last_page+1);
	       		}
	       	}

		},

		watch: {
			source(){
				this.setPages();
			}
		}
	}
</script>

<style scoped>
	@media print { 
        .noprint, .noprint *
        {
            display: none !important;
        }
    }
</style>